import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { MarkupProfileAction } from '../../markupProfile.action';

export const MarkupProfileListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(MarkupProfileAction.loadList.started());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(MarkupProfileAction.destroy());
    };
  }, [dispatch]);

  return null;
};
